module.exports = {"name":"powerUpSlots","audiences":["allMembers"],"autoTrack":true,"experimentAllocation":{"allMembers":1},"defaultWeight":1,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/powerUpSlots.json
// module id = eRb/
// module chunks = 1